import { render } from "./GoalsCard.vue?vue&type=template&id=00648b5c&scoped=true"
import script from "./GoalsCard.vue?vue&type=script&lang=js"
export * from "./GoalsCard.vue?vue&type=script&lang=js"

import "./GoalsCard.vue?vue&type=style&index=0&id=00648b5c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00648b5c"

export default script